import { render, staticRenderFns } from "./Folder.vue?vue&type=template&id=2800ecde&scoped=true&"
import script from "./Folder.vue?vue&type=script&lang=ts&"
export * from "./Folder.vue?vue&type=script&lang=ts&"
import style0 from "./Folder.vue?vue&type=style&index=0&id=2800ecde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2800ecde",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VTextField})
